import API from "../../../global/api";
//Action types
export const LOGIN_ADMIN_SUCCESS = "LOGIN_ADMIN_SUCCESS";
export const LOGIN_ADMIN_ERROR = "LOGIN_ADMIN_ERROR";

// Request Actions


export const getFilledStatus = (data) => {
  return (dispatch) => {
     dispatch(requestFilled());
    API.post(`/petitional/is-filled`,data).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successFilled(data));
    });
  };
};

export const requestFilled = () => {
  return {
    type: "REQUEST_IS_FILLED",
  };
};
export const successFilled = (data) => {
  return {
    type: "SUCCESS_IS_FILLED",
    payload: data,
  };
};
export const errorFilled = (data) => {
  return {
    type: "ERROR_IS_FILLED",
    payload: data,
  };
};


const loginAdminSuccess = (data) => ({
  type: LOGIN_ADMIN_SUCCESS,
  payload: data,
});

export const loginAdminError = () => ({
  type: LOGIN_ADMIN_ERROR,
});

//Api calls

export const getLogin = (username, password) => {
  return (dispatch) => {
    API.post(`/users/user-login`, {
      email: username,
      password: password,
    })
      .then((res) => {
        let data = res.data;

        window.localStorage.setItem(
          "current_user_username",
          `${data.email}`
        );

        dispatch(loginAdminSuccess(data));
        
        window.localStorage.setItem("auth_id", `${data.token}`);
        window.localStorage.setItem("isAdmin", false);
        window.localStorage.setItem("isAuthenticated", true);
        window.localStorage.setItem("up", data.user_package);
       
        window.localStorage.setItem("user_id", `${data.user_id}`);
        window.localStorage.setItem("auth_id", `${data.token}`);
        window.location.replace("/Landing-Page");
      })
      .catch((error) => {
        dispatch(loginAdminError())
            });
  };
};



export const changePassword = (data) => {
  return (dispatch) => {
    API.post(`users/change-password-user`,data).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successChangePassword(data));
    }).catch((error) => {
      dispatch(errorChangePassword())
          });
  };
};

export const requestChangePassword = () => {
  return {
    type: "REQUEST_CHANGE_PASSWORD",
  };
};
export const successChangePassword = (data) => {
  return {
    type: "SUCCESS_CHANGE_PASSWORD",
    payload: data,
  };
};
export const errorChangePassword = (data) => {
  return {
    type: "ERROR_CHANGE_PASSWORD",
    payload: data,
  };
};